<template>
  <div class="overlay" :style="overlayStyles">
    <div class="overlay-bg" :style="overlayStyles"></div>
    <div v-if="data.attributesText" class="attribute-container">
      <span v-for="(attributeText, index) in data.attributesText" :key="index" class="text">
        {{ attributeText }}
      </span>
    </div>
    <div v-if="isPremium && !isMerchOnly" class="tag-container premium-container">
      <span class="text">{{ $t('main.vectors.commonOverlay.text') }}</span>
      <div class="icon-container">
        <img
          src="https://cdn.vexels.com/img/icons/crown.svg"
          :alt="$t('preview.main.content.crownAlt')"
          width="20"
          height="20"
          loading="lazy"
        />
      </div>
    </div>
    <div v-if="isMerchOnly" class="tag-container formerch-container">
      <span class="text">{{ $t('main.vectors.commonOverlay.text2') }}</span>
      <div class="icon-container">
        <img
          src="https://cdn.vexels.com/img/icons/merch_only.svg"
          :alt="$t('preview.main.content.merchOnlyIconAlt')"
          width="28"
          height="20"
          loading="lazy"
        />
      </div>
    </div>
    <div class="title-container">
      <h3 class="text">{{ data.name }}</h3>
    </div>
    <div class="like-container-wrapper">
      <div class="like-container" @click.stop.prevent="likeVector(data.id)">
        <span class="text">{{ $t('main.vectors.commonOverlay.text3') }}</span>
        <div class="icon-container">
          <Icon
            :width="30"
            :height="30"
            class="icon like-icon"
            :class="{ liked: isLiked }"
            :icon="likeIcon"
          />
        </div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import Icon from 'UI/Icon';

export default {
  components: {
    Icon
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      hoveringDiv: false
    };
  },
  computed: {
    likeIcon() {
      return this.isLiked ? 'like-full' : 'like-empty';
    },
    overlayStyles() {
      return `border-radius: ${this.data.borderRadius}px;`;
    },
    isLiked() {
      return this.$store.getters['user/isVectorLiked'](parseInt(this.data.id));
    },
    isPremium() {
      if (!this.data.attributes) return false;
      return this.data.attributes.some((el) => Number(el.id) == this.$g('PREMIUM_ATTRIBUTE_CODE'));
    },
    isMerchOnly() {
      if (!this.data.attributes) return false;
      return this.data.attributes.some(
        (el) => Number(el.id) == this.$g('MERCH_ONLY_ATTRIBUTE_CODE')
      );
    }
  },
  methods: {
    likeVector(idVector) {
      this.$store.dispatch('user/SET_LIKE_VECTOR', {
        idVector,
        isLiked: this.isLiked,
        bvModal: this.$bvModal
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  transition: 0.4s ease;
  overflow: hidden;
  z-index: 2;
  div {
    z-index: 100;
  }
  &:hover {
    .title-container,
    .like-container,
    .download-container,
    .premium-container,
    .attribute-container,
    .formerch-container {
      opacity: 1;
    }
    .overlay-bg {
      background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.3));
      height: 70%;
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }
}
.like-container-wrapper {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.like-container {
  width: 38px;
  height: 38px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  z-index: 2;
  opacity: 0;
  border-radius: 7px;
  margin-top: 10px;
  transition: all 0.3s ease-out;
  box-sizing: border-box;
  .icon-container {
    top: 3px;
  }
  .text {
    font-size: 12px;
    min-width: 10px;
    padding: 10px;
    width: max-content;
    position: absolute;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: inherit;
    color: #fff;
    transform: scaleX(0);
    border-radius: 7px 0px 0px 7px;
    top: 0;
    right: 38px;
    opacity: 0;
    transform-origin: right center;
    z-index: -1;
    transition: inherit;
    box-sizing: border-box;
  }
}
.like-container:hover {
  background-color: #fb556b;
  border-radius: 0px 7px 7px 0px;
  .text {
    right: 37px;
    transform: scaleX(1);
    opacity: 1;
  }
}
.attribute-container {
  transition: 0.4s ease;
  opacity: 0;
  position: absolute;
  display: flex;
  flex-direction: column;
  .text {
    float: left;
    margin-top: 10px;
    margin-left: 10px;
    padding: 2px 6px;
    background-color: white;
    border-radius: 2px;
    box-shadow: 0px 3px 6px #0000001a;
    -webkit-box-shadow: 0px 3px 6px #0000001a;
    -moz-box-shadow: 0px 3px 6px #0000001a;
    display: flex;
    font-size: 11px;
    color: black;
    width: max-content;
  }
}
.tag-container {
  float: right;
  margin-top: 10px;
  margin-right: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.4s ease;
  height: 38px;
  width: 120px;
  padding-right: 38px;
  position: relative;
  .text {
    font-size: 12px;
    color: white;
    width: max-content;
    overflow: hidden;
    transition: opacity 0.4s ease-in;
    position: absolute;
  }
}
.premium-container {
  opacity: 0;
  .text {
    margin: 2px 11px;
    opacity: 1;
  }
  .icon-container {
    width: 35px;
  }
}
.formerch-container {
  opacity: 0;
}
.icon-container {
  height: 20px;
  position: absolute;
  right: 0;
  width: 38px;
  display: flex;
  align-content: center;
  top: 8px;
}
.icon-container > .icon {
  height: 100%;
  margin: auto;
}
.title-container {
  opacity: 0;
  position: absolute;
  bottom: 0;
  margin-left: 10px;
  margin-bottom: 10px;
  color: white;
  font-weight: 500;
  transition: 0.4s ease;
  width: 74%;
  h3 {
    font-size: 16px;
    margin-bottom: 0;
  }
}

@media all and (max-width: 767px) {
  .title-container {
    font-size: 15px;
  }
}
@media all and (max-width: 550px) {
  .title-container {
    font-size: 13px;
  }
}
</style>
<style lang="scss">
.like-container:hover {
  .svg-icon::before {
    color: white !important;
  }
}
</style>
